import { render, staticRenderFns } from "./ComplieHeaderMenu.vue?vue&type=template&id=645b7d04&scoped=true"
import script from "./ComplieHeaderMenu.vue?vue&type=script&lang=js"
export * from "./ComplieHeaderMenu.vue?vue&type=script&lang=js"
import style0 from "./ComplieHeaderMenu.vue?vue&type=style&index=0&id=645b7d04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645b7d04",
  null
  
)

export default component.exports